import * as Yup from "yup";

export const partnerFormShema = Yup.object().shape({
  brand_name: Yup.string().required("Brand Name is required"),
  status: Yup.string().required("Status is required"),
  color_code: Yup.string().required("Color Code is required"),
  logo: Yup.array().required("Logo  is required"),
});
